import React from 'react';

import { Global } from '@emotion/react';
import styled from '@emotion/styled';
import { Text, Button } from '@myrealtrip/web-ui';

import errorGlobalStyle from '~styles/errorGlobals';

export default function RuntimeError() {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <ErrorContainer>
      <Global styles={errorGlobalStyle} />
      <ErrorBackdrop />
      <ErrorSection>
        <ErrorHeader>
          <ErrorTitle typography="headlineBold20">일시적인 오류가 발생했습니다.</ErrorTitle>
          <ErrorDescription typography="paragraphNormal15">
            잠시 후 다시 시도해 주세요.
          </ErrorDescription>
        </ErrorHeader>
        <ErrorActionBar>
          <ErrorActionButton variant="secondary" onClick={handleRefresh}>
            <Text typography="paragraphBold15">확인</Text>
          </ErrorActionButton>
        </ErrorActionBar>
      </ErrorSection>
    </ErrorContainer>
  );
}

const ErrorContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 500px;
`;

const ErrorBackdrop = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: ${({ theme: { palettes } }) => palettes.gray[1000]};
  opacity: 0.4;
  backdrop-filter: blur(25px);

  @media (min-width: 768px) {
    background-color: ${({ theme: { palettes } }) => palettes.white};
  }
`;

const ErrorSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  position: absolute;
  width: 374px;
  max-width: calc(100% - 16px);
  min-height: 181px;
  background: #fff;
  box-shadow: ${({ theme: { shadows } }) => shadows.E500};
  border-radius: 34px;
  > *:not(:last-of-type) {
    margin-bottom: 8px;
  }
`;

const ErrorHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 4px 4px 24px;
  width: 334px;
  max-width: 100%;
  min-height: 85px;
  > *:not(:last-of-type) {
    margin-bottom: 10px;
  }
`;

const ErrorTitle = styled(Text)`
  color: ${({ theme: { palettes } }) => palettes.gray[1000]};
  line-height: 130%;
`;

const ErrorDescription = styled(Text)`
  color: ${({ theme: { palettes } }) => palettes.gray[700]};
`;

const ErrorActionBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 48px;
`;

const ErrorActionButton = styled(Button)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 13.5px 14px;
  height: 48px;
  background-color: ${({ theme: { palettes } }) => palettes.gray[80]};
  border-radius: 24px;
  > *:not(:last-of-type) {
    margin-right: 2px;
  }
`;
